import { Switch, useRouteMatch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoutes";

import Earn from "./Earn";
import History from "./History";
import Fund from "./FundEarnWallet";
import Transfer from "./Transfer";
import RequestLoan from "./RequestLoan";
import Earnings from "./AvailableEarnings";
import CoinEarnings from "./CoinEarnings";
import CoinEarningDetails from "./CoinEarningDetails";
import Subscribe from "./Subscribe";
import Staking from "./Staking";
// import LoanDetails from "./LoanDetails";

const EarnRoot = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <ProtectedRoute exact path={path} component={Earn} />
      <ProtectedRoute exact path={`${path}/staking`} component={Staking} />
      <ProtectedRoute exact path={`${path}/history`} component={History} />
      <ProtectedRoute exact path={`${path}/request`} component={RequestLoan} />
      <ProtectedRoute exact path={`${path}/earnings`} component={Earnings} />
      <ProtectedRoute exact path={`${path}/subscribe`} component={Subscribe} />

      <ProtectedRoute
        exact
        path={`${path}/earnings/:coin`}
        component={CoinEarnings}
      />

      <ProtectedRoute
        exact
        path={`${path}/earnings/:coin/:id`}
        component={CoinEarningDetails}
      />
      <ProtectedRoute
        exact
        path={`${path}/transfer/:coin`}
        component={Transfer}
      />

      <ProtectedRoute exact path={`${path}/fund/:coin`} component={Fund} />

      {/* <ProtectedRoute
        exact
        path={`${path}/:id/payback`}
        component={PaybackLoan}
      />
      <ProtectedRoute
        exact
        path={`${path}/:id/details`}
        component={LoanDetails}
      /> */}
    </Switch>
  );
};

export default EarnRoot;
